import { render, staticRenderFns } from "./InsuredFilter.vue?vue&type=template&id=f240babc&"
import script from "./InsuredFilter.vue?vue&type=script&lang=js&"
export * from "./InsuredFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports